import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { ACCESS_TYPE } from 'src/app/angular-elements/producer/ssos/health-sherpa-sso/configs/enums/access-type.enum';
import { HealthSherpaSSOService } from 'src/app/angular-elements/producer/ssos/health-sherpa-sso/services/health-sherpa-sso.service';
import { environment } from 'src/environments/environment';
import { MemberData } from '../../interfaces/find-member-response.interface';
import { PrePopulatedDataStateStructure } from '../configs/interfaces/prePopulatedDataStateStructure.interface';
import { HealthSherpaAEMConfigItem, OFF_EXCHANGE_STRATEGIES } from '../find-customer/configs/interfaces/find-customer-aem-data.interface';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { NgRedux } from '@ptl/angular-redux-store';
import { StateStructure } from '@ptl/state';
import { DateService } from 'src/app/shared/services/date.service';
import { PrePopulateData, savePrepopulatedData } from '../configs/reducers/prePopulatedData.reducer';
import { PtlWindowLocationService } from '@ptl/global-components';
import { Person } from 'src/app/angular-elements/form-wrappers/form-components/individual-market-persons/interfaces/person.interface';
import moment from 'moment';
import { IndividualMarketStateStructure } from 'src/app/angular-elements/form-wrappers/plan-enrollment/individual-plan-enrollment-form/configs/interfaces/individualMarket.interfaceStateStructure';
import { saveIndividualState } from 'src/app/angular-elements/form-wrappers/plan-enrollment/individual-plan-enrollment-form/configs/reducers/individual-market.reducer';
import { of } from 'rxjs';
import { PrepopulatedFields } from '../interfaces/prepopulated-fields.interface';
@Component({
    selector: 'app-member-card',
    templateUrl: './member-card.component.html',
    styleUrls: ['./member-card.component.scss'],
    standalone: false
})
export class MemberCardComponent implements OnInit, OnChanges {

  /** Response data for individual enrollee */
  @Input() memberData: MemberData;
  /** RetentionId shared by all enrollees from query */
  @Input() retentionId: number;

  @Input() enrollPageUrl: string;
  @Input() healthSherpaRegionConfig: string;
  @Input() buttonContentSubmitAsHealthSherpa: string;
  @Input() buttonContentSubmitAsShopX: string;

  angularHostUrl: string;

  showMedical = true;
  showDental = true;
  showVision = true;

  isSubmitDisabled: boolean;

  constructor(
    private healthSherpaSSOService: HealthSherpaSSOService,
    private reducerUtilityService: ReducerUtilityService,
    private ngRedux: NgRedux<StateStructure>,
    private dateUtility: DateService,
    private windowLocationService: PtlWindowLocationService
  ) {
    this.angularHostUrl = environment.infrastructure.googleCloud.angularHostUrl;
  }

  ngOnInit(): void {
    this.ngRedux.dispatch(saveIndividualState(null));
   }

  ngOnChanges(changes) {
    this.showMedical = changes.memberData.currentValue['coverageData']['medical'];
    this.showDental = changes.memberData.currentValue['coverageData']['dental'];
    this.showVision = changes.memberData.currentValue['coverageData']['vision'];
  }

  showContinueButton(): boolean {
    // If ShopX Flow && OEP, return true
    // If HealthSherpa, return True
    return true
  }

  // TODO: this should not be contextualized around HealthSherpa. HealthSherpa is the exception, not the rule.
  isHealthSherpaRegion() {

    /** Parse it.... */
    const healthSherpaRegionConfigAsJson: HealthSherpaAEMConfigItem[] = (() => {
      if (this.healthSherpaRegionConfig) {
        try {
          const parsed = JSON.parse(this.healthSherpaRegionConfig);
          return parsed;
        } catch (e) {
          console.error('AEM Config for find-customer component\'s healthSherpaRegionConfig is not populated');
          return [];
        }
      } else {
        return [];
      }
    })();

    /** Peruse it... */
    const aemArray = healthSherpaRegionConfigAsJson.filter(i => {
      return (i.stateOrRegion && i.stateOrRegion.toUpperCase()) === (this.memberData?.homeAddress?.state?.toUpperCase());
    });

    /** Check it... */
    if (aemArray && aemArray.length > 0) {
      return aemArray[0].offExchangeStrategy === OFF_EXCHANGE_STRATEGIES.HEALTH_SHERPA;
    }
  }

  async onSubmit() {
    /** Health Sherpa */
    if (this.isHealthSherpaRegion()) {
      this.isSubmitDisabled = true;
      await this.healthSherpaSSOService.doSSO(
        ACCESS_TYPE.CURRENTLY_ENROLLED,
        this.retentionId
      );
      this.isSubmitDisabled = false;
    } else {
      /** SHOPX - not implemented */
      // TODO: Implement ShopX Strategy.
      this.savePrepopulatedData();
      this.windowLocationService.goToUrl(this.enrollPageUrl);
    }
  }

  savePrepopulatedData() {
    const isChildOnly: 'Yes' | 'No' = this.memberData?.groups[0]?.childOnly === true ? 'Yes' : 'No';
    const prePopulateData: PrePopulatedDataStateStructure = this.reducerUtilityService.getState('PrePopulateData');
    // save the prepopulated fields
    //the service returns child only data as the subscriber and this will then save "dependent" data to the subscriber prefill fields 
    //therefore we should only return if it is NOT child only flow
    if(isChildOnly === 'No'){
      prePopulateData.prepopulatedFields.firstName = this.memberData?.fullName?.firstName;
      prePopulateData.prepopulatedFields.lastName = this.memberData?.fullName?.lastName;
      prePopulateData.prepopulatedFields.addressLine1 = this.memberData?.homeAddress?.address;
      prePopulateData.prepopulatedFields.addressLine2 = this.memberData?.homeAddress?.address2;
      prePopulateData.prepopulatedFields.city = this.memberData?.homeAddress?.city;
      prePopulateData.prepopulatedFields.state = this.memberData?.homeAddress?.state;
      prePopulateData.prepopulatedFields.personalPhoneNumber = this.memberData?.phone;
      prePopulateData.prepopulatedFields.zipCode = this.memberData?.homeAddress?.zipCode;
      const dateOfBirth = this.dateUtility.getDateAsFormattedString(this.memberData?.dateOfBirth, 'MM/DD/YYYY');
      prePopulateData.prepopulatedFields.dob = dateOfBirth;
      prePopulateData.prepopulatedFields.effectiveStartDate = this.memberData?.effectiveDate && this.dateUtility.getDateAsFormattedString(this.memberData?.effectiveDate, 'MM/DD/YYYY');
      this.ngRedux.dispatch(savePrepopulatedData(prePopulateData.prepopulatedFields));
    }
    else{
      const emptyPrepopFields: PrepopulatedFields = {} as PrepopulatedFields;
      this.ngRedux.dispatch(savePrepopulatedData(emptyPrepopFields));
    }
    
    this.storeIndividualPlansState(this.memberData, isChildOnly);
  }

  storeIndividualPlansState(memberData: MemberData, isChildOnly: 'Yes' | 'No') {
    let indState: IndividualMarketStateStructure = {} as IndividualMarketStateStructure;

    let subscriber: Person[] = [];
    
    subscriber = this.extractPersonData(subscriber, 'SUBSCRIBER');

    let spouse: Person[] = [];
    spouse = this.extractPersonData(spouse, 'SPOUSE');

    let dependents: Person[] = [];
    dependents = this.extractPersonData(dependents, 'DEPENDENT');

    const subscriberFormatted = isChildOnly === 'Yes' ? {} : { 0: subscriber[0] };

    const spouseFormatted = { 0: spouse[0] };

    const dependentsFormatted = (() => {
      if(isChildOnly === 'Yes'){
        return {0: subscriber[0]};
      }
      const returnable = {};
      dependents.forEach( (d, i) => {
        returnable[i] = d;
      });
      return returnable;
    })();
    
    //in child only the child is returned as the subscriber
    indState.ratingInfo = {
      subscriber: subscriberFormatted,
      'spousal-partner': spouseFormatted,
      dependents: dependentsFormatted,
      effectiveDate: ''
    };
    indState.childOnlyPolicy = isChildOnly;
    if(isChildOnly === "Yes"){
      indState.multipleChildrenOnPolicy = "No"
    }
  
    this.ngRedux.dispatch(saveIndividualState(indState));
  }


  private extractPersonData(persons: Person[], relationship: string) {
      const isChildOnly: boolean = this.memberData.groups[0]?.childOnly
      this.memberData?.groups?.forEach(group => {
      const relationshipDefinedPerson = group?.persons?.filter(person => person?.relationship.toUpperCase() === relationship.toUpperCase());
      persons = relationshipDefinedPerson?.map(dep => {
        if(isChildOnly && dep?.relationship === "Subscriber"){
          dep.relationship = "Dependent";
        }
        //default and generic person object
        let individualPersonData = {
          dob: moment.utc(dep?.dob).format(),
          gender: dep?.gender,
          firstName: dep?.fullName?.firstName,
          lastName: dep?.fullName?.lastName,
          relationship: dep?.relationship
        } as Person;

        //noSSN field only exists if there is noSSN, and ssn field only exists if there IS one.
        //they only exist simultaneously if the checkbox is interacted with otherwise
        if(dep?.ssn !== "" && dep?.ssn !== null && dep?.ssn){
          individualPersonData.ssn = dep?.ssn;
        }else{
          individualPersonData.noSSN = true;
        }
        return individualPersonData;
      });
    });
    return persons;
  }

}
